import React from "react";
import styles from "./BonusInformation.module.css";

import Grid from "@material-ui/core/Grid";
import CheckIcon from "@material-ui/icons/Check";
import Typography from "@material-ui/core/Typography";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import PhoneIcon from "@material-ui/icons/Phone";

function BonusInformation(props) {
  return (
    <div className={styles.container}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
          <div className={styles.box} id={styles.box_1}>
            <CheckIcon className={styles.icon} id={styles.icon_1} />
            <Typography
              variant="subtitle1"
              gutterBottom
              className={styles.content}
            >
              100% sản phẩm tốt, chất lượng tốt và giá cả phải chăng
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={styles.box} id={styles.box_2}>
            <AutorenewIcon className={styles.icon} id={styles.icon_2} />
            <Typography
              variant="subtitle1"
              gutterBottom
              className={styles.content}
            >
              5 ngày đổi trả hàng miễn phí với điều kiện sản phẩm còn nguyên,
              chưa sử dụng
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={styles.box} id={styles.box_3}>
            <PhoneIcon className={styles.icon} id={styles.icon_3} />
            <Typography
              variant="subtitle1"
              gutterBottom
              className={styles.content}
            >
              Miễn phí tư vấn khách hàng 24/7
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default BonusInformation;
